import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LuArrowLeft } from 'react-icons/lu';
import { Icon } from '../lib/icons';
import { motion } from 'framer-motion';
import styles from './Legal.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

const Legal: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname;

  let titleKey = '';
  let contentKey = '';

  if (path === '/legal') {
    titleKey = 'legal.legalTitle';
    contentKey = 'legal.legalContent';
  } else if (path === '/terms') {
    titleKey = 'legal.termsTitle';
    contentKey = 'legal.termsContent';
  } else if (path === '/privacy') {
    titleKey = 'legal.privacyTitle';
    contentKey = 'legal.privacyContent';
  } else if (path === '/anti-abuse') {
    titleKey = 'legal.antiAbuseTitle';
    contentKey = 'legal.antiAbuseContent';
  }

  const title = t(titleKey);
  const content = t(contentKey);

  return (
    <div className={styles.legal}>
      <motion.div
        className={styles.inner}
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <Link to="/" className={styles.backLink}>
          <Icon icon={LuArrowLeft} size={14} strokeWidth={2} />
          {t('common.back')}
        </Link>

        <h1 className={styles.title}>{title}</h1>
        <p className={styles.lastUpdated}>
          {t('legal.lastUpdated' as string) || 'Last updated'}: 01/01/2024
        </p>

        <div className={styles.content}>
          {content}
        </div>
      </motion.div>
    </div>
  );
};

export default Legal;
